import {BestWorstSellersReportModel} from "./best-worst-sellers-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-best-worst-sellers-report",
    templateUrl: "./best-worst-sellers-report.component.html",
    providers: [provideReportModel(BestWorstSellersReportModel)]
})
export class BestWorstSellersReportComponent extends AbstractReportPage {
    constructor(public model: BestWorstSellersReportModel) {
        super();
    }
}
